import { ReactNode, useEffect, useState } from 'react';
import { useFlag } from '@unleash/proxy-client-react';
import { shouldRenderOperatorChat } from 'features/assetControl/assetControl.utils';
import useAuth from 'hooks/useAuth';
import { GreenerUnit } from 'types';

const PAGE_TITLE_KEYS: Record<string, string> = {
  graphs: 'unitControl:navigation.graphs',
};

export const useUnitDetailTopbarState = ({ pathname, asset }: { pathname: string; asset: GreenerUnit | undefined }) => {
  const { user } = useAuth();
  const isChatEnabled = useFlag('chat');
  const [isChatSplit, setIsChatSplit] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [rightTopbarSlot, setRightTopbarSlot] = useState<ReactNode>(null);

  const splitPath = pathname.split('/');
  const postFix = splitPath[splitPath.length - 1];
  const pageTitleKey = PAGE_TITLE_KEYS[postFix];

  const isHmiTabPage = pathname.includes('/hmi/') && !pathname.endsWith('/hmi/menu');
  const isChatVisible = shouldRenderOperatorChat(user?.role, asset, isChatEnabled);

  useEffect(() => {
    if (!isChatVisible) {
      setIsOpen(false);
      setIsChatSplit(false);
    }
  }, [asset, isChatEnabled, user?.role]);

  return {
    postFix,
    pageTitleKey,
    isHmiTabPage,
    isChatVisible,
    isChatSplit,
    setIsChatSplit,
    isOpen,
    setIsOpen,
    rightTopbarSlot,
    setRightTopbarSlot,
  };
};
